/**
 * @file  Analyst
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React, {useContext} from 'react';
import {Table, Divider} from 'antd';
import {BasicLayoutContext} from '~/layout/BasicLayout';

import './index.less';

const columns = [
    {
        title: 'Firm',
        dataIndex: 'firm',
        key: 'firm',
        width: 353
    },
    {
        title: 'Analyst',
        dataIndex: 'analyst',
        key: 'analyst',
        width: 353
    }
];

const data = [
    {
        key: '1',
        firm: 'BOCOM International',
        analyst: 'Connie Gu'
    },
    {
        key: '2',
        firm: 'China Merchants Securities (Hong Kong)',
        analyst: 'Tommy Wong'
    },
    // {
    //     key: '3',
    //     firm: 'China Renaissance Securities',
    //     analyst: 'Yiwen Zhang'
    // },
    {
        key: '4',
        firm: 'Citigroup Global Markets Inc.',
        analyst: 'Alice Cai'
    },
    {
        key: '5',
        firm: 'CITIC Securities',
        analyst: 'Chongguang Feng'
    },
    {
        key: '6',
        firm: 'CLSA Limited',
        analyst: 'Elsie Sheng'
    },
    {
        key: '7',
        firm: 'First Shanghai Group',
        analyst: 'Tracy Dan'
    },
    {
        key: '8',
        firm: 'Goldman Sachs',
        analyst: 'Timothy Zhao'
    },
    {
        key: '9',
        firm: 'Haitong International',
        analyst: 'Daisy Chen'
    },
    {
        key: '10',
        firm: 'Huatai Securities',
        analyst: 'Bo Zhan'
    },
    {
        key: '11',
        firm: 'TF Securities',
        analyst: 'Haiyang Sun'
    }

];


function Analyst() {
    const layoutContext = useContext(BasicLayoutContext);
    const {isMobile} = layoutContext ?? {};

    return (
        <div className="analyst-container">
            {
                isMobile && (
                    <>
                        <div className="analyst-container-title">
                            Analyst Coverage
                        </div>
                        <Divider />
                    </>
                )
            }
            <Table
                columns={columns}
                dataSource={data}
                pagination={false}
            />
        </div>
    );
}

export default Analyst;
